import { render, staticRenderFns } from "./ChangeCollaboratorModal.vue?vue&type=template&id=4d1113ad"
import script from "./ChangeCollaboratorModal.vue?vue&type=script&lang=js"
export * from "./ChangeCollaboratorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports